<template>
  <SimpleTriggerList></SimpleTriggerList>
</template>

<script>
  import SimpleTriggerList from '../components/SimpleTriggerList';

  export default {
    name: "SimpleTriggerView",

    components: {
      SimpleTriggerList
    }
  }
</script>

<style scoped>

</style>
